import React, { useState,useCallback,forwardRef } from 'react';
var classNames = require("classnames");
const CharCounterInput = forwardRef((props, ref) => {
      var textAreaMaxLimit = classNames({
        maxLimit: true,
        textareaMax:window.config.isTextArea?true:false
      });
    const [inputValue, setInputValue] = useState('');
    const maxChars = 250;
    const handleChange = useCallback(
        (event) => {
            let value=event.target.value;
            // Only update the state if the new value is within the character limit
            if (value.length <= maxChars) {
                setInputValue(value);
                props.onChange(event); // Pass the new value along with the call
            }
        },
        [maxChars, props]
    );

    return (
            <><div>{window.config.isTextArea?<textarea
            ref={ref}
            onKeyDown={props.handleKeyDown}
            placeholder={props.placeholder}
            className={props.className}
            autoFocus={props.autoFocus}
            onChange={handleChange}
            value={inputValue}
            name="textarea"
            maxLength={maxChars} />:<><input
            ref={ref}
            placeholder={props.placeholder}
            className={props.className}
            autoFocus={props.autoFocus}
            onChange={handleChange}
            type={props.type}
            value={inputValue}
            maxLength={maxChars} /><div  className={textAreaMaxLimit}>
                {inputValue.length}/{maxChars}
            </div></>}
           </div></>
    );
});

export default CharCounterInput;